export default function PermissionsPage() {
  return <div><h2>Права</h2><p>Здесь будет управление правами доступа (только для администратора).</p></div>;
} 